import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import parse from "html-react-parser";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const ArticleDetails = () => {
  const { articleId } = useParams(); // ✅ استخراج ID المقال من الرابط
  const { i18n } = useTranslation();
  const activeLanguage = i18n.language;
  const isRTL = i18n.language === "ar"; // ✅ التحقق من اللغة لتحديد الاتجاه

  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const response = await axios.get(`https://demo-two.keytime.sa/api/articles/${articleId}`);
        setData(response.data); // ✅ تعيين البيانات
        setIsLoading(false);
      } catch (err) {
        setError("لم يتم العثور على المقالة.");
        setIsLoading(false);
      }
    };

    fetchArticle();
  }, [articleId]); // 🔹 تحديث عند تغيير `articleId`

  return (
    <>
      <Helmet>
        <title>{data ? data.name : "تحميل..."}</title>
      </Helmet>

      <div className="w-[80%] flex flex-col mx-auto my-10">
        {isLoading ? (
          <div className="text-center text-lg font-semibold animate-pulse">جارٍ تحميل المقال...</div>
        ) : error ? (
          <div className="text-red-500 text-center">{error}</div>
        ) : (
          <>
            {/* ✅ عرض الصورة */}
            <div className="w-full h-[400px] rounded-lg overflow-hidden mb-6 shadow-lg">
              <img 
                src={`/serviceImages/${data.thumbnail}`} 
                alt={data.name} 
                className="w-full h-full object-cover"
              />
            </div>

            {/* ✅ عرض العنوان مع اتجاه النص */}
            <h1 className={`text-3xl font-bold mb-4 ${isRTL ? "text-right" : "text-left"}`}>
              {activeLanguage === "ar" ? data.name : data.name_en}
            </h1>

            {/* ✅ عرض المحتوى مع الحفاظ على التنسيق */}
            <div 
              className={`prose prose-lg prose-gray max-w-full leading-8 text-gray-800 ${isRTL ? "text-right" : "text-left"}`}
              style={{ whiteSpace: "pre-line" }}
            >
              {activeLanguage === "ar" ? parse(data.content) : parse(data.content_en)}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ArticleDetails;
